import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { getRequest } from '../../axios/axios';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

const ServiceName = () => {
  const { id } = useParams();
  const location = useLocation();
  const isOrderDetailPage = location?.pathname?.split('/')?.[1] === 'ServiceOrderDetails' ? false : true;

  const servicerId = id;
  const statusFlg = useSelector((state) => {
    return state?.accountDetail?.status;
  });
  const getServicerNameFromRedux = useSelector((state) => {
    return state?.accountDetail?.ServicerName;
  });
  const getServicerFromLocalStorage = localStorage?.getItem('servicerName');
  const getServicerAccountIdFromLocalStorage = sessionStorage?.getItem('servicerAccountId');

  const getServicerAccountNumberFromRedux = useSelector((state) => {
    return state?.accountDetail?.ServicerAccountNumber;
  });
  const getAccountDetails = async () => {
    let response;
    if (statusFlg === 'Set up for Dispatch') {
      response = await getRequest(`/api/getServicerAccount?servicerId=${servicerId}`, 'sdProvider');
    } else if (statusFlg === 'Inactive Servicer') {
      response = await getRequest(`/api/getServicerAccount?servicerId=${servicerId}`, 'sdProvider');
    } else {
      response = await getRequest(`/api/getServicerAccount?servicerId=${servicerId}`, 'sdProvider');
    }
    if (response?.data?.isSuccess) {
      window.localStorage.setItem('isdCode', response?.data?.data?.isdCode);
      window.localStorage.setItem('phoneRegionCode', response?.data?.data?.phoneRegionCode);
      window.localStorage.setItem('servicerName', response?.data?.data?.accountData?.account?.businessName);
      window.sessionStorage.setItem(
        'EligibleFileClaimWithoutJob',
        response?.data?.data?.accountData?.account?.fileClaimWithoutJob,
      );
      window.sessionStorage.setItem('servicerId', response?.data?.data?.servicerId);
    }
  };

  useEffect(() => {
    if (servicerId && isOrderDetailPage) {
      getAccountDetails();
    }
  }, []);

  const generateServicerDetails = (
    getServicerNameFromRedux,
    getServicerAccountNumberFromRedux,
    getServicerFromLocalStorage,
    getServicerAccountIdFromLocalStorage,
  ) => {
    if (getServicerNameFromRedux) {
      return `${getServicerNameFromRedux ? getServicerNameFromRedux : ''}  ${
        getServicerAccountNumberFromRedux ? `(${getServicerAccountNumberFromRedux})` : null
      }`;
    } else if (getServicerFromLocalStorage && getServicerAccountIdFromLocalStorage) {
      return `${getServicerFromLocalStorage + '(' + getServicerAccountIdFromLocalStorage + ')'}`;
    }
    return '';
  };

  return (
    <>
      <Typography sx={{ color: '#1E384B', fontSize: '14px' }}>
        {generateServicerDetails(
          getServicerNameFromRedux,
          getServicerAccountNumberFromRedux,
          getServicerFromLocalStorage,
          getServicerAccountIdFromLocalStorage,
        )}
      </Typography>
    </>
  );
};
export default ServiceName;
